import { TOTP_PROVIDER_AMPLITUDE_EVENT } from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import { getFactorApplicationName } from '../../utils/widget-facade';
import BaseForgeCustomizer from '../base-forge';

export default class ActivatePushClassicCustomizer extends BaseForgeCustomizer {
  displayFooterText = true;
  protected applicationName = getFactorApplicationName();
  headerDescription = this.applicationName ? `Enter the code displayed in your ${this.applicationName}` : '';

  async shouldCustomize() {
    return [ 'activate-push' ].includes(this.context?.controller);
  }

  async customize() {
    await super.customize();
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT['OKTA']}TotpActivatePush::Landing`);
  }

  protected primaryButtonOnClick = () => {
    AmplitudeUtils.logMfaEnrollEvent(`${TOTP_PROVIDER_AMPLITUDE_EVENT['OKTA']}TotpActivatePush::VerifyButtonClick`);
  };
}
